export default "__VITE_ASSET__88c66622__"